import { Avatar, Box, Button, Grid, Modal, Paper, TextField, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

const UpdateProfile = ({ 
  open, 
  handleClose, 
  name, 
  setName, 
  email, 
  setEmail, 
  pass, 
  setPass, 
  newPass, 
  setNewPass, 
  allowSubmit, 
  setAllowSubmit, 
  updateProfileHandler 
}) => {
  return (
                <Modal
                      open={open}
                      onClose={handleClose}
      
                      sx={{ border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
      
                      <Box sx={{ width: { lg: '80vw' }, padding: '2vh 2vw 6vh 2vw', outline: 'none', borderRadius: '6px', backgroundColor: 'white', position: 'relative' }}>
                          <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                              <Button onClick={handleClose} sx={{ boxShadow: 2, color: 'red', '&:hover': { boxShadow: 5 } }}>
                                  <CloseIcon />
                              </Button>
                          </Grid>
                          <Grid sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 2 }} >
                              <Typography sx={{ fontFamily: "Mont-SemiBold", fontSize: '1.3rem' }}>Update Profile</Typography>
                              <Grid item xs={10.2} sx={{ backgroundColor: 'red', height: "1vh" }}></Grid>
                          </Grid>
                          <Grid sx={{ mt: 4, display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                              <TextField id="outlined-basic" multiline label="Name" variant="outlined" sx={{ width: '100%' }} value={name} onChange={(e) => {
                                  setName(e.target.value)
                                  setAllowSubmit(true)
                              }} />
                              <TextField id="outlined-basic" disabled multiline label="Email" variant="outlined" sx={{ width: '100%', mt: 2 }} value={email} onChange={(e) => {
                                  setEmail(e.target.value)
                                  setAllowSubmit(true)
                              }} />
                              <TextField id="outlined-basic" multiline label="Change Password" variant="outlined" sx={{ width: '100%', mt: 2 }} value={pass} onChange={(e) => {
                                  setPass(e.target.value)
                                  setAllowSubmit(true)
                              }} />
                              <TextField id="outlined-basic" multiline label="Confirm Password" variant="outlined" sx={{ width: '100%', mt: 2 }} value={newPass} onChange={(e) => {
                                  setNewPass(e.target.value)
                                  setAllowSubmit(true)
                              }} />
                              <Grid sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                  <Button disabled={!allowSubmit} onClick={updateProfileHandler} variant='contained' sx={{ backgroundColor: 'red', '&:hover': { color: 'red', backgroundColor: 'white' }, padding: '1.5vh 2vw', textTransform: 'none', fontFamily: 'Mont-Regular', mt: 4 }}>Save Changes</Button>
                              </Grid>
                          </Grid>
      
                      </Box>
      
                  </Modal>
  )
}
export default UpdateProfile